"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertBinder = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * debug utility for checking binder type in graphics / transform component.
 */
function assertBinder(binder, id) {
    DEBUG_MODE && rc_js_util_1._Debug.assert(binder.binderClassificationId === id, `binder does not match interface, asked for "${id.toString()}" but got "${binder.binderClassificationId.toString()}"`);
}
exports.assertBinder = assertBinder;
//# sourceMappingURL=assert-binder.js.map